.scrim {
  position: fixed;
  inset: 0;
  background: rgba(20, 18, 16, 0.55);
  opacity: 0;
  pointer-events: none;
  transition: opacity 220ms ease;
  z-index: 90;
}

.scrimOpen { opacity: 1; pointer-events: auto; }

.panel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: min(86vw, 360px);
  background: #1a1714;
  color: #f5f2ee;
  z-index: 91;
  transform: translateX(-104%);
  transition: transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 12px 0 40px rgba(0, 0, 0, 0.35);
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
}

.panelOpen { transform: translateX(0); }

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.brand {
  font-family: var(--font-display);
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.back, .close {
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
  padding: 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.back { padding-left: 0; font-size: 0.85rem; letter-spacing: 0.06em; }

.search {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 14px 18px 8px;
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(245, 242, 238, 0.7);
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
  font-size: 0.92rem;
  text-align: left;
}

.search:hover { background: rgba(255, 255, 255, 0.1); color: #f5f2ee; }

.panes {
  flex: 1;
  position: relative;
  overflow: hidden;
}

.pane {
  position: absolute;
  inset: 0;
  overflow-y: auto;
  padding: 8px 0 24px;
  background: #1a1714;
  transform: translateX(0);
  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease;
}

.paneSub {
  transform: translateX(102%);
  opacity: 0;
}

.paneIn {
  transform: translateX(0);
  opacity: 1;
}

.paneOut {
  transform: translateX(-30%);
  opacity: 0.4;
}

.sectionLabel {
  padding: 16px 22px 8px;
  font-size: 0.65rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(245, 242, 238, 0.45);
  font-weight: 700;
}

.subTitle {
  padding: 6px 22px 14px;
  font-family: var(--font-display);
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 22px;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  font-size: 1.05rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
  position: relative;
  transition: background 140ms ease, padding-left 140ms ease;
}

.row::before {
  content: "";
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 0;
  background: var(--color-ember);
  transition: height 160ms ease;
}

.row:hover, .row:focus-visible {
  background: rgba(255, 255, 255, 0.05);
  padding-left: 26px;
  outline: none;
}

.row:hover::before, .row:focus-visible::before { height: 60%; }

.rowLabel { display: inline-flex; flex: 1; }

.utilityRow {
  display: block;
  width: 100%;
  padding: 12px 22px;
  background: transparent;
  border: 0;
  color: rgba(245, 242, 238, 0.78);
  font: inherit;
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
}

.utilityRow:hover { color: #f5f2ee; }
